import Axios, { AxiosInstance, AxiosResponse } from 'axios';

class HttpClient {
  private client: AxiosInstance;

  constructor() {
    const client = Axios.create({
      baseURL: process.env.REACT_APP_SERVER_URL || '',
    });

    client.interceptors.response.use(this.handleSuccess, this.handleError);

    const token = this.getToken();

    if (token) {
      client.defaults.headers.Authorization = `Bearer ${token}`;
    }

    this.client = client;
  }

  private getToken(): string | null {
    return localStorage.getItem('@AtacDelivery:token');
  }

  public setToken(token: string): void {
    this.client.defaults.headers.Authorization = `Bearer ${token}`;
  }

  private handleSuccess(response: AxiosResponse<any>): AxiosResponse<any> {
    return response;
  }

  private handleError(error: any): any {
    const errorStatusCode = error?.response?.status;

    if (errorStatusCode && errorStatusCode === 401) {
      localStorage.removeItem('@AtacDelivery:token');
      localStorage.removeItem('@AtacDelivery:user');

      window.location.reload();
    }

    return Promise.reject(error);
  }

  public get(url: string): Promise<AxiosResponse<any>> {
    return this.client.get(url);
  }

  public post(url: string, payload: any): Promise<AxiosResponse<any>> {
    return this.client.post(url, payload);
  }

  public patch(url: string, payload: any): Promise<AxiosResponse<any>> {
    return this.client.patch(url, payload);
  }

  public put(url: string, payload: any): Promise<AxiosResponse<any>> {
    return this.client.put(url, payload);
  }

  public delete(url: string): Promise<AxiosResponse<any>> {
    return this.client.delete(url);
  }
}

export default new HttpClient();
